import React, { useId, useState } from "react";

const FileUpload = ({
  onFileSelect,
  accept,
  maxSize,
  currentFile,
  disabled = false,
  label = "Click to browse or drag and drop",
  helperText,
  error,
  className = "",
}) => {
  const inputId = useId();
  const errorId = `${inputId}-error`;
  const helperId = `${inputId}-helper`;
  const statusId = `${inputId}-status`;
  const [statusMessage, setStatusMessage] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file && onFileSelect) {
      if (maxSize && file.size > maxSize) {
        const msg = `File size must be less than ${(maxSize / 1024 / 1024).toFixed(0)}MB`;
        setStatusMessage(msg);
        return;
      }
      setStatusMessage(`Selected: ${file.name}`);
      onFileSelect(file);
    }
  };

  return (
    <div className={`w-full ${className}`}>
      <div className="border-2 border-dashed border-gray-400 rounded-lg p-6 text-center hover:border-gray-600 transition-colors focus-within:ring-2 focus-within:ring-blue-600">
        <input
          type="file"
          id={inputId}
          className="sr-only"
          onChange={handleFileChange}
          accept={accept}
          disabled={disabled}
          aria-invalid={error ? true : undefined}
          aria-describedby={
            [helperText ? helperId : null, error ? errorId : null, statusId]
              .filter(Boolean)
              .join(" ") || undefined
          }
        />
        <label
          htmlFor={inputId}
          className={`cursor-pointer inline-block ${
            disabled ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          <svg
            className="w-12 h-12 text-gray-700 mx-auto mb-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
            />
          </svg>
          <p className="text-sm text-gray-900">{label}</p>
          {currentFile ? (
            <p className="text-sm text-green-800 mt-2">
              Selected: {currentFile.name}
            </p>
          ) : (
            helperText && (
              <p id={helperId} className="text-xs text-gray-700 mt-1">
                {helperText}
              </p>
            )
          )}
        </label>
      </div>
      <div id={statusId} className="sr-only" aria-live="polite">
        {statusMessage}
      </div>
      {error && (
        <p id={errorId} className="text-sm text-red-700 mt-2" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};

export default FileUpload;
